import { render, staticRenderFns } from "./editQuestionnaire.vue?vue&type=template&id=4dac028c&scoped=true&"
import script from "./editQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./editQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./editQuestionnaire.vue?vue&type=style&index=0&id=4dac028c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac028c",
  null
  
)

export default component.exports